import React from "react";
import {CardContent, CardHeader, Button, Typography} from "@mui/material";
import {useState} from "react";
import {useDispatch} from "react-redux";
import {setModal} from "../../../../Common/App";
import {DialogCard} from "../../../../../Components/Cards/DialogCard";
import {Alert, Loader} from "../../../../../Components";
import DialogActions from "@mui/material/DialogActions";
import { removeUserFromDepartment } from "../../../../Core/Users";

export const ConfirmUserRemovalModal = ({department_id, user}) => {

    const dispatch = useDispatch();
    const [, setErrors] = useState({});
    const [message, setMessage] = useState("");
    const [status, setStatus] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async () => {
        setIsLoading(true);
        await removeUserFromDepartment({dispatch, data:{department_id, id: user.id}}).then((res) => {
            if(res.success){
                dispatch(setModal({component:null, open:false}));
            }
            setIsLoading(false);
            setErrors(res.errors)
            setMessage(res.message)
            setStatus(res.status)
        })
    };

    return(
        <DialogCard>
            <CardHeader
                title={`Remove User - ${user?.first_name} ${user?.last_name}`}
                avatar={<Loader isLoading={isLoading} type={"linear"}/>}
            />
            <CardContent sx={{ p: 2, pt:2 }}>
                {message && (
                    <Alert severity={status} sx={{ mb: 2 }}>
                        {message}
                    </Alert>
                )}
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    This will remove <strong>{user.first_name} {user.last_name}</strong> from the current department and move them to "No Department" (parking). Their roster assignments and access permissions may be affected.
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    Are you sure you want to proceed with this action?
                </Typography>
            </CardContent>
            <DialogActions sx={{ mb: 2, mr: 2 }}>
                <Button onClick={() => dispatch(setModal({component:null, open:false}))}>Cancel</Button>
                <Button disabled={isLoading} variant="contained" color={'error'} onClick={ handleSubmit }>Remove User</Button>
            </DialogActions>
        </DialogCard>
    )
}